export default {"src":"/bnb/_next/static/media/walletconnect.88159341.svg","height":20,"width":20};